import { defineFcm } from '../shared/factory';

export const FCM_PROMOTED_AUTO_RECO_DIGEST_EMAIL_PROMOTION_COUNT = defineFcm(
	'promoted_auto_reco_digest_email_promotion_count',
)
	.asNumber()
	.withDefault(undefined)
	.toConfig();
